<template>
    <div>
        <div class="password-input-container">
            <div class="input-group mb-3 w-100 rounded-0">
                <input class="form-control rounded-0" v-model="password" name="password"
                    placeholder="Password" :class="{ 'border-secondary': isFocused }"
                    :type="showPassword ? 'text' : 'password'" @focus="isFocused = true" @blur="isFocused = false">
                <div class="input-group-append">
                    <span class="input-group-text rounded-0 border-left-0" :class="{ 'border-secondary': isFocused }"
                        @click="showPassword = !showPassword">
                        <i :class="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                    </span>
                </div>
            </div>

            <div class="d-flex mb-3" style="gap: 5px;">
                <span class="flex-grow-1 rounded" :class="{
                    'bg-danger': enhancedScore == 1,
                    'bg-warning': enhancedScore == 2,
                    'bg-info': enhancedScore == 3,
                    'bg-success': enhancedScore == 4,
                    'bg-light': enhancedScore < 1
                }">
                    <div class="small" :class="{
                        'text-light': enhancedScore < 1,
                        'text-warning': enhancedScore == 2,
                        'text-info': enhancedScore == 3,
                        'text-success': enhancedScore == 4
                    }">
                        {{ strengthWord }}
                    </div>
                </span>
                <span class="flex-grow-1 rounded" :class="{
                    'bg-warning': enhancedScore == 2,
                    'bg-info': enhancedScore == 3,
                    'bg-success': enhancedScore == 4,
                    'bg-light': enhancedScore < 2
                }">
                    <div class="small" :class="{
                        'text-light': enhancedScore < 2,
                        'text-info': enhancedScore == 3,
                        'text-success': enhancedScore == 4
                    }">
                        {{ strengthWord }}
                    </div>
                </span>
                <span class="flex-grow-1 rounded" :class="{
                    'bg-info': enhancedScore == 3,
                    'bg-success': enhancedScore == 4,
                    'bg-light': enhancedScore < 3
                }">
                    <div class="small" :class="{
                        'text-light': enhancedScore < 3,
                        'text-success': enhancedScore == 4
                    }">
                        {{ strengthWord }}
                    </div>
                </span>
                <span class="flex-grow-1 rounded" :class="{
                    'bg-success': enhancedScore == 4,
                    'bg-light': enhancedScore < 4
                }">
                    <div class="small" :class="{
                        'text-light': enhancedScore < 4,
                    }">
                        {{ strengthWord }}
                    </div>
                </span>
            </div>
        </div>
        <div class="alert alert-info"
            v-if="enhancedFeedback.warningArray[0] && enhancedFeedback.warningArray.length > 0"
            style="white-space: pre-line;">
            <ul>
                <li v-for="warning in enhancedFeedback.warningArray">{{ warning }}</li>
            </ul>
        </div>
    </div>
</template>
<script>
import zxcvbn from "zxcvbn";

//Added dictionary list to test for prohibited words. Also checked in backend when password reset request is sent. 
//For consistency and to avoid unnecessary errors it is imperative that this list be kept identical to the one in OBO-accounts-storage.
const dictionaryList = [
    'cabcard',
    'ccs',
    'taxi',
    'driver',
    'fleet',
    'merchant',
    'gateway',
    'optimus',
]

export default {
    name: 'password',
    computed: {
        passwordStrength() {
            return zxcvbn(this.password, dictionaryList)
        },
        enhancedFeedback() {
            // Get original feedback from zxcvbn
            const originalFeedback = this.passwordStrength.feedback || { warning: '', suggestions: [] };

            if (originalFeedback.warning !== "") {
            }
            // Create a new feedback object to avoid modifying the original
            let feedback = {
                warning: originalFeedback.warning,
                suggestions: [...(originalFeedback.suggestions || [])]
            };

            //Add custom warning when prohibited word is detected.
            for (let i = 0; i < dictionaryList.length; i++) {
                const inList = this.password.toLowerCase().search(dictionaryList[i]);
                if (inList > -1) {
                    if (feedback.warning) {
                        feedback.warning = "Password contains words from prohibited list." + feedback.warning;
                    } else {
                        feedback.warning = "Password contains words from prohibited list";
                    }
                }
            }

            // Add custom warning for password length
            if (this.password && this.password.length < 8 && this.password.length > 0) {
                if (feedback.warning) {
                    feedback.warning = "Password should be at least 8 characters long." + feedback.warning;
                } else {
                    feedback.warning = 'Password should be at least 8 characters long';
                }
            }
            const warningArray = feedback.warning.split(".")
            return { warningArray };
        },
        enhancedScore() {
            // Get the original score from zxcvbn
            const originalScore = this.passwordStrength.score || 0;

            // Create a variable to store the modified score
            let modifiedScore = originalScore;

            // Check for prohibited words
            for (let i = 0; i < dictionaryList.length; i++) {
                const inList = this.password.toLowerCase().search(dictionaryList[i]);
                if (inList > -1) {
                    // Override the score to 0 when a prohibited word is found
                    modifiedScore = 0;
                    break; // Exit the loop once a prohibited word is found
                }
            }

            // Return the (potentially modified) score
            return modifiedScore;
        },
        strengthWord() {
            switch (this.enhancedScore) {
                case 1:
                    return 'Weak';
                case 2:
                    return 'Fair';
                case 3:
                    return 'Good';
                case 4:
                    return 'Strong';
                default:
                    return 'Empty';
            }
        },
    },
    data() {
        return {
            password: '',
            passwordScore: null,
            showPassword: false,
            isFocused: false
        }
    },
    watch: {
        password(newValue) {
            this.$emit('password-changed', newValue);
            let passwordScore = this.enhancedScore
            this.$emit('password-score-changed', passwordScore);
        },
    }
};
</script>
<style>
</style>